/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type UserNotice = {
    id: number;
    type: UserNotice.type;
    severity: UserNotice.severity;
    titleKey: string | null;
    messageKey: string;
    params: Record<string, any> | null;
    primaryActionRoute: string | null;
    primaryActionLabelKey: string | null;
    dismissible: boolean;
    raisedAt: string;
};
export namespace UserNotice {
    export enum type {
        CALENDAR_SYNC_FAILED = 'calendar_sync_failed',
    }
    export enum severity {
        INFO = 'info',
        WARNING = 'warning',
        ERROR = 'error',
    }
}

